export default __webpack_public_path__ + "static/media/howItWorkstwo.a94628d5.png";